// Source for a full fenced mermaid block that captures inner diagram content.
export const MERMAID_BLOCK_WITH_CAPTURE_SOURCE = '```mermaid\\n([\\s\\S]*?)```';

// Source for a full fenced mermaid block without capture.
export const MERMAID_BLOCK_SOURCE = '```mermaid[\\s\\S]*?```';

// Non-global presence test (safe to reuse; no lastIndex concerns).
export const MERMAID_BLOCK_TEST = /```mermaid/;
